// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ACLSE","index":"styles_index__3Fcqv"};